export const pageTitle = { fontSize: 30 };
export const titleButton = { marginRight: 8 };
export const exitIcon = { fontSize: '160%' };
